'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'flask-round-potion';
var width = 448;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M160 170.6l0-10.7L160 16l128 0 0 143.9 0 10.7 9.8 4.1C367.3 203.7 416 272.2 416 352c0 5.4-.2 10.7-.6 15.9c-62.6-1.3-98.7-16.1-130.3-31.1c-3.1-1.5-6.2-3-9.3-4.5C245.9 317.9 217.1 304 171.8 304c-49.2 0-87.3 12.4-113.2 24.8c-11.1 5.3-19.9 10.6-26.4 15c3.2-76.3 51-141.1 118-169.1l9.8-4.1zM413.4 383.9c-7.4 44.4-30 83.6-62.4 112.1L97 496c-37.2-32.8-61.6-79.8-64.7-132.5c1.4-1.1 3.4-2.7 5.9-4.4c6.1-4.3 15.2-10 27.3-15.8C89.6 331.6 125.4 320 171.8 320c41.5 0 67.2 12.4 97 26.8c3.1 1.5 6.1 3 9.3 4.5c32.6 15.5 70.6 31.1 135.2 32.6zM304 159.9L304 16l24 0 8 0 0-16-8 0L304 0 288 0 160 0 144 0 120 0l-8 0 0 16 8 0 24 0 0 143.9C68.8 191.3 16 265.5 16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-86.5-52.8-160.7-128-192.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;